import {
  ChangeDetectionStrategy,
  Component
} from "@angular/core";
import { InformationContentComponent } from "../../layout/information-content/information-content.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-peronal-data",
    templateUrl: "./personal-data.component.html",
    imports: [InformationContentComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalDataComponent {}
